import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { checkoutQueries } from '@as-react/common-queries';
import { isBasketNotFound, isBasketNotInitialized } from '@as-react/common-utils';
import { useQuery } from '@tanstack/react-query';
import { TextAlpha } from '@yonderland/andes-react';
import { isAxiosError } from 'axios';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { useDeliveryState } from '../../../../context/CheckoutDeliveryContext';
import { showNamedDays } from '../../../../util/BuyFormUtil';
import { formatTimeStampToDateParts, isTomorrow } from '../../../../util/DateUtil';
import { DeliveryPreselectedCardView } from '../DeliveryPreselectedCardView';
const DeliveryDateLabel = ({ date, locale, customWeekday }) => {
    const { weekday, day, month } = formatTimeStampToDateParts(date, locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
    });
    return (_jsxs(TextAlpha, { strong: true, children: [customWeekday || weekday, " ", `${day} ${month}`] }));
};
export const HomeDeliveryDayPreview = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const { defaultRequestParams, servicesEndpoint, root, locale } = useAemConfig();
    const [{ info, activeDeliveryOption }, dispatch] = useDeliveryState();
    const { getNamedDayDeliveryDates } = checkoutQueries({ servicesEndpoint, defaultRequestParams });
    const { data: deliveryDates, error: deliveryDatesError } = useQuery(getNamedDayDeliveryDates({
        enabled: showNamedDays(activeDeliveryOption),
    }));
    useEffect(() => {
        if (isAxiosError(deliveryDatesError)) {
            if (isBasketNotFound(deliveryDatesError) || isBasketNotInitialized(deliveryDatesError)) {
                location.href = `${root}checkout/basket-overview.html`;
            }
        }
    }, [deliveryDatesError]);
    if (!deliveryDates) {
        return null;
    }
    const deliveryDate = deliveryDates.find(date => { var _a; return date.date.toString() === ((_a = info.deliveryDate) === null || _a === void 0 ? void 0 : _a.toString()); });
    const getDeliveryDateLabel = (date) => isTomorrow(date.date) ? (_jsx(DeliveryDateLabel, { date: date.date, locale: locale, customWeekday: t('checkout.delivery.delivery.day.tomorrow') })) : (date.label);
    const handleEditDeliveryDay = () => {
        dispatch({ type: 'set_open_selector', payload: 'delivery-day' });
    };
    const getHeaderContent = () => (_jsxs(_Fragment, { children: [_jsx(TextAlpha, { variant: "bodyS", children: t('checkout.delivery.delivery.day.title') }), _jsx(TextAlpha, { strong: true, children: getDeliveryDateLabel(deliveryDate ? deliveryDate : deliveryDates[0]) })] }));
    return (_jsx(DeliveryPreselectedCardView, { testId: "hd_date_card", header: getHeaderContent(), onEdit: handleEditDeliveryDay }));
};
